// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-16c1dcca] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.title .default-bar[data-v-16c1dcca] {\n    width: 3px;\n    height: 14px;\n    background: #5088ff;\n    display: block;\n    margin-right: 8px;\n}\n.right-btn[data-v-16c1dcca] {\n  cursor: pointer;\n  color: #5088ff;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
